import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers/rootReducer';
import { baseApi } from '../endpoints/createApi';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

export default store;
